import { useEffect } from 'react'

import { Text } from '@components/ui-core/text/text'

import style from './text-field.module.scss'

/**
 * a dummy text field to demo how Grammarly integrates with the text field.
 * it has an empty line at the end of the content, so G button can have enough space to show full size
 * @returns
 */
export const TextField = ({
  onFocus,
  contentRef,
  setContentRef,
}: {
  onFocus: () => void
  contentRef: HTMLDivElement | null
  setContentRef: (ref: HTMLDivElement) => void
}) => {
  useEffect(() => {
    const content = contentRef as HTMLParagraphElement
    const focusOnAnchor = () => {
      // `requestAnimationFrame` to make sure the selection is done after the focus event is triggered
      requestAnimationFrame(() => {
        // use selection to make sure the cursor is at the end of the content
        const sel = window.getSelection()

        const range = document.createRange()
        range.selectNodeContents(content)
        range.collapse(false)

        sel?.removeAllRanges()
        sel?.addRange(range)
      })

      onFocus()
    }

    content?.addEventListener('focus', focusOnAnchor)

    return () => {
      content?.removeEventListener('focus', focusOnAnchor)
    }
  }, [onFocus, contentRef])

  return (
    <div className={style.container} data-color-scheme="light">
      <div className={style.header}>
        <div className={style.dotContainer}>
          <div className={style.dot} />
          <div className={style.dot} />
          <div className={style.dot} />
        </div>
        <Text className={style.headerText}>Try out Go here</Text>
      </div>
      <div className={style.contentContainer}>
        <div
          ref={setContentRef}
          className={style.content}
          contentEditable
          dangerouslySetInnerHTML={{
            __html: `
        <h1>Demo: Zephyr Campaign Update</h1>
        <p>
          A meeting was held by our team on Monday with the client team for the Zephyr project to
          review the status of the forthcoming Q3 launch campaign. The campaign, originally built as
          a omnichannel activation across CTV, paid social and programmatic display, is now subject
          to substantial midstream revisions as has been detailed in a previous update.
        </p>
        <p>
          We conduct a daily standup each morning through end of week to identify blockers. The next
          client check-in is scheduled for July 3rd, where we preview asset revisions and confirm
          compliance milestones. Final go/no-go is slated for July 7th at 17:00 PDT. We are
          proceeding with all mitigations in parallel, and escalated any dependency delays as they
          surface.
        </p>
        <p></p>`,
          }}
        />
      </div>
    </div>
  )
}
